module.exports = __webpack_public_path__ + "img/photo4.6fb68d15.png";